import classNames from "classnames";
import styles from "../Digikala.module.css";

export default function DigikalaBenefits({ benefits }) {
  return (
    <div className="row rtl d-flex justify-content-center flex-wrap py-4 mt-5">
      <div className="col-12">
        <h2 className="text-secondary font-weight-bold h3 text-center mb-0">
          {benefits.title}
        </h2>
      </div>

      <div className="col-12 d-flex justify-content-center pt-3 row rtl flex-wrap w-100">
        {benefits.cards.map((item, idx) => (
          <div
            key={idx}
            className="col-12 col-sm-6 col-md-6 col-lg-4 p-2 position-relative"
            style={{ maxWidth: 300 }}
          >
            <div
              className={classNames(
                "card shadow h-100 py-1",
                styles.digikalaCard
              )}
            >
              <div className="card-body">
                <div className="row rtl d-flex justify-content-center flex-wrap text-center">
                  <div className="col-12 pb-2">
                    <h3 className="h6" style={{ color: "#482b88" }}>
                      {item.title}
                    </h3>
                  </div>

                  <div className="col-12">
                    <h6 className="text-muted font-weight-bold h6">
                      {item.description}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
